import { render, staticRenderFns } from "./menuUpper.vue?vue&type=template&id=2cebbb6f&scoped=true&"
import script from "./menuUpper.vue?vue&type=script&lang=ts&"
export * from "./menuUpper.vue?vue&type=script&lang=ts&"
import style0 from "./menuUpper.vue?vue&type=style&index=0&id=2cebbb6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cebbb6f",
  null
  
)

export default component.exports